import { Snackbar } from '.';
import { Component } from '../../helpers/compiler';

@Component({ className: 'js-snackbar' })
export class SnackbarComponent {
	constructor(private element: HTMLElement) {
		new Snackbar(this.element);
	}
}
